<template>
  <div class="indicatorPointsContainer">
    <div class="header">
      <div class="title">毕业要求指标点</div>
    </div>
    <div class="indicatorPointsInfo">
      <div class="infoTitle">{{code}}. {{name}}指标点</div>
      <div class="infoContent">
        <div class="contentItem" v-for="(item, index) in indicatorPointsData" :key="index">
          <div class="itemHeader">
            <div class="itemIndex">{{item.code}}<div class="circle"></div></div>
            <div class="itemInfo">{{item.content}}</div>
          </div>
          <div class="itemBody">
            <div class="bodyItem" v-for="(course, i) in item.courseList" :key="i" @click="syllabus(course)">{{course.courseName}}</div>
          </div>
        </div>
      </div>
    </div>
    <back-to :path="'/graduationRequirements'"></back-to>
  </div>
</template>
<script>
import api from '@/api'
import backTo from '@/components/back'
export default {
  components: { backTo },
  data() {
    return {
      indicatorPointsData: [],
      code: '',
      name: ''
    }
  },
  created() {
    this.code = localStorage.getItem('claimCode')
    this.name = localStorage.getItem('claimName')
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$get(api.indicatorPoints.list(), { graduationId: localStorage.getItem('claimId') }).then(res => {
        res.forEach(item => {
          item.code = localStorage.getItem('claimCode') + '.' + item.code
        })
        this.indicatorPointsData = res
      })
    },
    syllabus(course){
      this.$router.push({
        path: '/syllabus',
        query: {
          from: 0,
          courseId: course.courseId,
          courseName: course.courseName
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.indicatorPointsContainer {
  background-color: #fff;
  .header {
    height: 150px;
    background-image: url('../../assets/bg-xiangqing-lv.png');
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    .title {
      font-size: 36px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      margin-top: 40px;
      letter-spacing: $letter-spacing;
    }
  }
  .indicatorPointsInfo {
    position: absolute;
    top: 120px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    border-radius: 40px 40px 0px 0px;
    padding: 40px 46px 38px;
    .infoTitle {
      text-align: center;
      margin-bottom: 59px;
      font-size:30px;
      font-family:PingFangSC;
      letter-spacing: $letter-spacing;
    }
    .infoContent {
      .contentItem {
        margin-bottom: 70px;
        .itemHeader {
          margin-bottom: 46px;
          .itemIndex {
            float: left;
            font-size:48px;
            color: $color-primary;
            margin-right: 31px;
            position: relative;
            z-index: 1;
            .circle {
              position: absolute;
              bottom: 10px;
              right: -10px;
              width:30px;
              height:30px;
              background-color: #c2f2df;
              border-radius: 50%;
              z-index: -1;
            }
          }
          .itemInfo {
            font-size:24px;
            color: #696969;
            line-height: 2;
          }
        }
        .itemBody {
          overflow: hidden;
          width: 100%;
          .bodyItem {
            float: left;
            width: 30%;
            height:70px;
            background:#F4F4F4;
            border-radius:10px;
            line-height: 70px;
            text-align: center;
            font-size:24px;
            color: #969696;
            letter-spacing: $letter-spacing;
            margin-bottom: 20px;
            margin: 0 1.6% 20px;
            @include text-ellipsis($line-clamp: 1);
            padding: 0 10px;
          }
        }
      }
    }
  }
}
</style>